<div>
  <div class="invoice-history">
    <div class="white-box">
      <div class="error-list" v-if="errorsInvoice">
        <ul class="error-msg">
            <li :key="x" v-for="(error,x) in errorsInvoice">
                <div :key="i" v-for="(err,i) in error">
                    <p> {{err}}</p>
                </div>
            </li>
        </ul>
    </div>
      <div class="table-title">
        <div class="container-fluid px-0">
          <div class="row align-items-center">

            <div class="col-lg-9">
              <h5>Invoice history</h5>
            </div>
            <!-- <div class="col-lg-3">
              <a
                href="#"
                class="btn add-btn"
                data-toggle="modal"
                data-target="#addInvoice"
              >
                <i class="fas fa-plus"></i>
                Add New Invoice</a
              >
            </div> -->
          </div>
        </div>
      </div>
      <div class="sort-wrapper">
        <div class="row">
            <div class="col-lg-6">
                <a @click.prevent="toggleFilter" aria-controls="collapseExample" aria-expanded="false"
                    class="filter-head up" role="button"><i class="fas fa-filter"></i> Show Filter
                </a>
            </div>
            <div class="col-lg-6">
                <div class="clear text-right">
                    <a @click.prevent="clearAllFilter" class="filter-head up"><i class="fas fa-redo"></i> Clear
                        all filters
                    </a>
                </div>
            </div>
        </div>
        <div class="collapse filter-body">
            <form action="#" class="content-block pb-0" id="formFilterTreks">
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label for="">Start Date</label>
                                <datetime @input="callInvoiceList()" format="yyyy-MM-dd"
                                    placeholder="Enter due date of invoice" v-model="RequestStartDate">
                                </datetime>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label for="">End Date</label>
                                <datetime @input="callInvoiceList()" format="yyyy-MM-dd"
                                    placeholder="Enter due date of invoice" v-model="RequestEndDate"></datetime>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <label for="">Status</label>
                                <multiselect :options='invoiceStatus' @input="callInvoiceList()"
                                             label="name" placeholder="Choose status" track-by="id"
                                             v-model="RequestStatus"></multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <hr />
    </div>
      <div class="table-container">
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light-bg">
              <tr>
                <th>Title</th>
                <th>Amount ($)</th>
                <th>Due date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(invoice,index) in InvoiceLists">
                <td>{{invoice.title}}</td>
                <td>{{invoice.amount}}</td>
                <td>{{invoice.due_date}}</td>
                                            <td>
                                <span class="badge badge-primary"
                                    v-if="invoice.status ==='draft'">{{invoice.status}}</span>
                                <span class="badge badge-secondary"
                                    v-if="invoice.status ==='unpaid'">{{invoice.status}}</span>
                                <span class="badge badge-success"
                                    v-if="invoice.status ==='paid'">{{invoice.status}}</span>
                                <span class="badge badge-danger"
                                    v-if="invoice.status === 'cancelled'">{{invoice.status}}</span>
                            </td>
                            <td>
                              <div class="includes-action justify-content-start" v-if="permission.invoice_retrieve">
                                       <button @click.prevent="redirectToView(invoice,index)" v-tooltip.top="{ content: 'View', class: 'tooltip-custom tooltip-other-custom' }"
                                      class="btn orange" href="#"><i class="fas fa-eye"></i></button>
                              </div>

                          </td>
              </tr>
            </tbody>
          </table>
          <div class="empty-data" v-if="InvoiceLists.length === 0">
            <p>
                No Invoice List
            </p>
        </div>
        <div class="spinner">
          <moon-loader :loading="ui.IsLoading" :size="50" v-if="InvoiceLists"></moon-loader>
      </div>

        </div>
      </div>
    </div>
    <Pager :pager="paging" @onPaging="onPaging"></Pager>
  </div>
  
  <!-- Modal -->
  <div class="modal-wrap">
    <div
      class="modal fade"
      id="addInvoice"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Create invoice</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-modified">
              <form action="">
                <div class="form-group">
                  <label for="">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter title of invoice"
                  />
                </div>
                <div class="form-group">
                  <label for="">Amount</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter amount of invoice"
                  />
                </div>
                <div class="form-group">
                  <label for="">Date</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter created date of invoice"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn default-btn">Ok</button>
            <button
              type="button"
              class="btn default-btn cancel"
              aria-label="Close"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
